<template lang="pug">
	sfc-modal(id="sfc-onboarding-modal-v3-3" title="")
		h2.title.text-left
			| {{title}}
		div
			sfc-update-email
</template>

<style lang="stylus" scoped>

</style>

<script>

import SfcUpdateEmail from '@/common/components/savings-center/v3/account/update-email'

export default {

	props: {
		savingsCenterFlow:{
			default: false
		},
		value:{
			default: true
		}
	},

	components: {
		SfcUpdateEmail
	},

	data() {
		return {
			title: "Account Settings",
		}
	},

	methods: {
		head(){
			return {
				title: `Savings Center - Learn - ${this.quickLinks[this.activeTab].text} - Saving for College`,
				meta: [
					{hid: "metadescription", name: 'description', content: `Savings Center - Learn - ${this.quickLinks[this.activeTab].text} - Saving for College`}
				],
			}
		}
	}

}
</script>
